import { errorMsg } from '@/utils/message';

export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if (typeof time === 'object') {
        date = time;
    } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
        if (result.length > 0 && value < 10) {
            value = '0' + value;
        }
        return value || 0;
    });
    return time_str;
}

/* export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if(diff < 30) {
    return '刚刚'
  } else if(diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if(diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if(diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if(option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}*/


export function formatTime(date) {
    if (date == null) {
        return '';
    }
    date = new Date(date);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

// export function formatTime(date) {
//   if(date==null) {
//     return '';
//   }
//   date = new Date(date);
//   const year = date.getFullYear();
//   const month = date.getMonth() + 1;
//   const day = date.getDate();
//   const hour = date.getHours();
//   const minute = date.getMinutes();
//   const second = date.getSeconds();
//   return [year, month, day].map(formatNumber).join('-') ;
//   //+ ' ' + [hour, minute, second].map(formatNumber).join(':')
// }

export function formatS(date) {
    var time = new Date(date * 1000);
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var hours = time.getHours();
    var minutes = time.getMinutes();
    var seconds = time.getSeconds();
    return year + '-' + month + '-' + date + ' ' + hours + ':' + minutes;
}

export function formatNumber(n) {
    n = n.toString();
    return n[1] ? n : '0' + n;
}

/* 格式化日期时间戳*/
export function formatDate(timeStamp, flag) {
    if (isStringEmpty(timeStamp)) {
        return timeStamp;
    }
    if (!flag) {
        timeStamp = timeStamp * 1000;
    }
    var date = new Date(timeStamp);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':');
}

/* 字符串是否为空*/
export function isStringEmpty(str) {
    str = String(str).trim();
    if (str === 'null' || str === 'undefined' || str === '') {
        return true;
    } else {
        return false;
    }
}
/* null等转为空字符串*/
export function getEmptyString(str) {
    if (str === null || str === undefined || str.trim() === '') {
        return '';
    } else {
        return str;
    }
}
/* 格式化error response*/
export function formatError(err) {
    var errStr = '';
    for (var key in err) {
        errStr += err[key][0] + '\n';
    }
    return errStr;
}

//格式化接口的catch(e)
export function formatException(e) {
    // console.log('e======',e);
    if(e.status&&e.request){
        if(typeof e.data === 'string'){
            return e.data
        }
        else if(e.data.title){
            return e.data.title;
        }
        return e.data;
    }
    if(e.errors){
        return e.title;
    }
    if (e.data && e.data.title) {
        return e.data.title;
    }
    return e.toString();
}

/* form验证错误信息*/
export function showError(errObj) {
    let isbreak = false;
    for (const key in errObj) {
        if (isbreak) {
            break;
        }
        for (let i = 0; i < errObj[key].length; i++) {
            errorMsg(errObj[key][i].message);
            isbreak = true;
            break;
        }
    }
    return false;
}

export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result;

    const later = function() {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp;

        // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last);
        } else {
            timeout = null;
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            }
        }
    };

    return function(...args) {
        context = this;
        timestamp = +new Date();
        const callNow = immediate && !timeout;
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }

        return result;
    };
}



// WEBPACK FOOTER //
// ./src/utils/index.js